export type ObjectValues<T> = T[keyof T]

export const typedEntries = <T extends Record<string, string>>(obj: T) =>
  Object.entries(obj) as [keyof T, T[keyof T]][]

export const typedOptions = <T extends Record<string, string>>(obj: T) =>
  typedEntries(obj).map(([value, label]) => ({ value, label }))
